import { TweekRepository } from 'tweek-local-cache';

import { getTweekClient } from './getTweekClient';

const repository: TweekRepository = new TweekRepository({
  client: getTweekClient(),
});
export const getTweekRepository = () => repository;
